<template>
  <v-container>
    <v-card max-width="800px">
      <v-card-title>
        <span class="headline">{{ "Use this form to change your password" }}</span>
      </v-card-title>
      <v-form>
        <v-card-text>
            <v-row class="xcompact">
              <v-col cols="12" sm="5">
                <v-text-field v-model="email" label="email" :disabled="adm == false">
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <v-text-field v-model="mNbr" label="Member #" :disabled="adm==false">
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="5">
                <v-text-field :type="password" v-model="pwd" label="Old password"
                              required
                              :rules="[v => !!v || 'Password is required']">
                </v-text-field>
              </v-col>
            </v-row>
          <v-row class="xcompact">
            <v-col cols="12" sm="5">
              <v-text-field :type="password" v-model="npwd" label="New password"
                            required
                            :rules="[v => !!v || 'Password is required',
                            v => (v && v.length >= 8) || 'Too short. Password must have at least 8 characters',
                            v => (v && v.length <= 50) || 'Too long. Password must have at most 50 characters',
                            v => (v && /[A-Z]+/.test(v)) || 'Password must include an upper case letter',
                            v => (v && /[a-z]+/.test(v)) || 'Password must include a lower case letter',
                            v => (v && /[0-9]+/.test(v)) || 'Password must include a number',
                            v => (v && /[/,{,},!,@,#,$,%,,^,(,),<,>,.,?,+,\-,=]+/.test(v)) || 'Password must include a special character',
                           ]">
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="5">
              <v-text-field :type="password" v-model="vpwd" label="New password again"
                            required
                            :rules="[ pwdSame || 'Passwords differ']">
              </v-text-field>
            </v-col>
          </v-row>
            <v-btn small color="primary" dark @click="doUpdate">Update</v-btn>
            <v-row class="xcompact">
              <v-col cols="6" sm="6" md="4">
                {{ loginMsg }}
              </v-col>
            </v-row>
        </v-card-text>
      </v-form>
    </v-card>
  </v-container>

</template>


<script>
export default {
  name: "PwdChange",
  data() {
    return {
      email: '',
      mNbr: '',
      password: 'Password',
      pwd: '',
      npwd: '',
      vpwd: ''
    }
  },
  methods: {
    doUpdate(e) {
      e.preventDefault()
      this.$http.post(this.$remote + '/api/modauth', {
        token: localStorage.getItem('token'),
        mNbr: this.mNbr,
        email: this.email,
        opw: this.pwd,
        npw: this.npwd
      })
          .then(response => {
            this.$usrStore.token = response.data.token
            localStorage.setItem('token', response.data.token)
            console.log(response)
            alert(response.data.message)
            this.$router.push('/member')
          })
          .catch(reason => {
            alert(reason.message)
      })
      this.$emit('endPwdChange')
    },
    mayChangeOthers() {
      return this.adm
    }
  },
  props: {
    emailx: {
      type: String
    },
    mNbrx: {
      type: String
    },
    aKey: {
      type: Number
    },
    adm: {
      type: Boolean,
      default: false
    }
  },
  mounted: function () {
    this.email = this.$usrStore.email
    this.mNbr = this.$usrStore.mNbr
  },
  watch: {
    aKey() {
      console.log(`aKey: ${this.aKey}`)
      this.email = this.emailx
      this.mNbr = this.mNbrx
    }
  },
  computed: {
    loginMsg() {
      return ''
    },
    pwdSame() {
      return this.npwd===this.vpwd
    },
  }
}
</script>

<style scoped>
.compact {
  padding-top: 0px;
  margin-top: 0px;
}
</style>
